import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Seo } from '@/components/Seo';
import { useGroundingSchemas } from '@/lib/useGroundingSchemas';
import { ArrowLeft } from 'lucide-react';

export default function KIAppMarketingPage() {
  const [htmlContent, setHtmlContent] = useState('');
  useGroundingSchemas(htmlContent, {
    headline: 'KI App Marketing 2026: Strategien, Tools & Erfolgsbeispiele',
    description: 'KI-gestütztes App Marketing revolutioniert User Acquisition: +340% CTR, -45% CPI. Entdecke AI-Tools, Strategien und Best Practices für 2026.',
    path: '/ki-app-marketing',
  });

  useEffect(() => {
    fetch('/grounding-pages/ki-app-marketing.html')
      .then(res => res.text())
      .then(html => {
        const bodyMatch = html.match(/<body[^>]*>([\s\S]*)<\/body>/i);
        if (bodyMatch) setHtmlContent(bodyMatch[1]);
      })
      .catch(err => console.error('Error loading grounding page:', err));
  }, []);

  return (
    <>
      <Seo
        title="KI App Marketing 2026: Strategien, Tools & Erfolgsbeispiele"
        description="KI-gestütztes App Marketing revolutioniert User Acquisition: +340% CTR, -45% CPI. Entdecke AI-Tools, Strategien und Best Practices für 2026."
        path="/ki-app-marketing"
        ogType="article"
      />

      <nav className="sticky top-0 z-50 bg-white border-b border-slate-200 shadow-sm">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl py-4">
          <div className="flex items-center justify-between">
            <Link to="/" className="flex items-center gap-2 text-slate-600 hover:text-teal-600 transition-colors">
              <ArrowLeft className="w-4 h-4" />
              <span className="hidden sm:inline">Zurück</span>
            </Link>
            <Link to="/" className="flex items-center gap-2">
              <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-teal-400 to-cyan-500 flex items-center justify-center">
                <span className="text-white font-bold text-sm">✦</span>
              </div>
              <span className="font-bold text-lg">
                mar<span className="text-teal-600">KI</span>pilot
              </span>
            </Link>
          </div>
        </div>
      </nav>

      <div className="grounding-page-content" dangerouslySetInnerHTML={{ __html: htmlContent }} />
      <style jsx>{`.grounding-page-content { max-width: 800px; margin: 0 auto; padding: 40px 24px; }`}</style>
    </>
  );
}